module.exports = __webpack_public_path__ + "static/media/right-arrow.09c10c82.png";